export default {
  getReplacementOptions() {
    return [
      {
        label: 'Brand',
        value: 'brand',
        example: 'LUX-camp',
      },
      {
        label: 'Domain',
        value: 'domain',
        example: 'luxcamp.de',
      },
      {
        label: 'Booking Ref',
        value: 'bookingRef',
        example: 'LU1000000',
      },
      {
        label: 'Customer Ref',
        value: 'customerRef',
        example: '111111',
      },
      {
        label: 'Customer Name',
        value: 'customerName',
        example: 'Placeholder Name',
      },
      {
        label: 'Family Name',
        value: 'familyName',
        example: 'Placeholder',
      },
      {
        label: 'Amount Due',
        value: 'amountDue',
        example: '102,4',
      },
      {
        label: 'Currency',
        value: 'currency',
        example: '€',
      },
      {
        label: 'Due Date',
        value: 'dueDate',
        example: '01-01-2020',
      },
    ];
  },
  getAttachmentOptions() {
    return [
      { id: 'invoice', name: 'Invoice' },
    ];
  },
  getExceptionTypes() {
    return [
      {
        type: 'amount',
        name: 'Amount',
        component: 'amount',
        labels: [{ label: 'Amount', value: 'minimumAmount' }],
      },
      {
        type: 'remark',
        name: 'Remark',
        component: 'remark',
      },
    ];
  },
  getRevisionHeaders() {
    return [
      { text: 'Revision', value: 'revision' },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Created By', value: 'userId' },
      { text: 'Action', sortable: false, width: '75px', class: 'text-xs-center' },
    ];
  },
  usedTemplates: (state) => {
    const templateIds = {};
    state.rules.rules.item.templates.forEach((item) => {
      templateIds[item.templateId] = true;
    });
    return templateIds;
  },
  getOverviewPoints() {
    return [
      { value: 'overdue', label: 'Overdue Without Reminders' },
      { value: 'lastReminder', label: 'Last Reminder' },
    ];
  },
  getSettingHeaders() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Type', value: 'type' },
      { text: 'Settings', value: 'data' },
      { text: 'Created By', value: 'user.firstName' },
      { text: 'Last Update', value: 'updatedAt' },
      { text: 'Status', sortable: false, width: '50px' },
    ];
  },
  getGlobalExceptionTypes() {
    return [
      { text: 'Date', value: 'date' },
      { text: 'Period', value: 'period' },
      { text: 'Weekday', value: 'weekday' },
    ];
  },
  getSettingsLogsHeaders() {
    return [
      { text: 'Updated By', value: 'user.firstName', sortable: false },
      { text: 'Updated At', value: 'createdAt' },
      { text: 'Action', value: 'action', sortable: false },
      { text: 'Comment', value: 'comment', sortable: false, width: '60px' },
    ];
  },
  getSettingActionTypes() {
    return {
      all: { text: 'All', value: 'all' },
      delete: { color: 'error--text', text: 'Delete', value: 'delete' },
      activate: { color: 'warning--text', text: 'Activate', value: 'activate' },
      update: { color: 'green--text', text: 'Update', value: 'update' },
      create: { color: 'info--text', text: 'Create', value: 'create' },
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/reminders/getters.js